module.exports = __webpack_public_path__ + "img/scam-hook.ddb5b7a.png";